var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.86 11.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: .61px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-dasharray: 0 0 0 0 7.13 1.43 16.5 0;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3057",
    className: "cls-1",
    d: "M15.65,5.52c0,2.88-2.34,5.22-5.22,5.22s-5.22-2.34-5.22-5.22S7.55.31,10.43.31s5.22,2.34,5.22,5.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3061",
    className: "cls-1",
    d: "M12.17,5.19c-.78,0-1.41-.63-1.41-1.41s.63-1.41,1.41-1.41,1.41.63,1.41,1.41-.63,1.41-1.41,1.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3065",
    className: "cls-2",
    d: "M10.43.31C3.27.43.31,5.52.31,5.52c0,0,2.97,5.09,10.12,5.22,7.16-.13,10.12-5.22,10.12-5.22,0,0-2.97-5.09-10.12-5.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3069",
    className: "cls-1",
    d: "M12.17,5.19c-.78,0-1.41-.63-1.41-1.41,0-.42.19-.8.48-1.06-.26-.07-.53-.12-.81-.12-1.61,0-2.91,1.31-2.91,2.91s1.31,2.91,2.91,2.91,2.91-1.31,2.91-2.91c0-.28-.04-.55-.12-.81-.26.29-.64.48-1.06.48Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVer);
export default __webpack_public_path__ + "static/media/Ver.b4ad5f0b475e960904dc0a4327c6fe13.svg";
export { ForwardRef as ReactComponent };